import _ from 'lodash';
import settings from '@/settings';
import store from '@/store';
import { DomainAuth } from '@/store/modules/domain/auth';

const generateHeaders = (
  authType: 'apiKey' | 'Bearer',
  // ヘッダーの値は不定のため除外
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers: { [key: string]: any }
) => {
  if (authType === 'apiKey') {
    return _.assignIn(headers, {
      'x-api-key': settings.apiKey,
    });
  }

  const context = DomainAuth.context(store);

  const { token } = context.state.token;

  return _.assignIn(headers, {
    Authorization: `Bearer ${token}`,
  });
};

export default generateHeaders;
